export default "__VITE_ASSET__7270f8a5__"